import React from 'react'
import { BsFillBoxSeamFill } from 'react-icons/bs';
import "./OrdersCard.css";
import { MdChevronRight } from 'react-icons/md';
import roundDiamond from "../../Assets/round-diamond-outline-removebg-preview.png";

const OrdersCard = () => {

    return (
        <>
            <div className='order-card-delivery-outter-card mt-5'>
                <div className='order-card-delivery-outter-inner container'>
                    <div className='order-card-delivery-div'>
                        <label className='order-card-delivery-icon'> <BsFillBoxSeamFill /> </label>
                        <label className=''>
                            <label className='fw-bold'> Delivered</label>
                            <label className='d-block text-muted delivery-date'>
                                On Mon,16 July 2024
                            </label>
                        </label>
                    </div>
                    <div className='order-card-img-product-name-all container'>
                        <label className='order-card-img-and-product-names'>
                            <img className='order-card-img-product-name-all-img-tag' src={roundDiamond} />
                        <label>
                            <span className='d-block fw-bold'> Melee Diamonds</span>
                            <span className='d-block'> Lorem ipsum</span>
                        </label>
                        </label>
                        <label className='order-card-img-product-right-arraow'> <MdChevronRight />                    </label>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrdersCard